import { computeBookingTaxQuote } from './gst/gstRules';

/**
 * Split a stored contract booking into Hire Value (A) vs Mobilization (B).
 * Mirrors create-time quote math from fixed_rate / attachment / client-paid mob.
 */
export function deriveContractMoneyBreakdown(booking) {
  const cycles = Number(booking?.quantity || 0);
  const fixed = Number(booking?.fixed_rate_per_cycle || 0);
  const attachRate = Number(booking?.attachment_rate_per_cycle || 0);
  const hireTaxable = Math.max(0, cycles * fixed);
  const attachTaxable = attachRate > 0 && cycles > 0 ? Math.max(0, cycles * attachRate) : 0;
  const combinedHireTaxable = hireTaxable + attachTaxable;

  const mobBy = booking?.mobilization_transport_by;
  const mobAmt = Number(booking?.mobilization_transport_amount || 0);
  const mobilizationCollected = mobBy === 'client' && mobAmt > 0;
  const mobTaxable = mobilizationCollected ? mobAmt : 0;

  const hireQuote = computeBookingTaxQuote(combinedHireTaxable);
  const mobQuote = mobilizationCollected ? computeBookingTaxQuote(mobTaxable) : null;
  const rate = Number(hireQuote.rate || 0.18);
  const pct = Number.isFinite(rate) && rate > 0 ? Math.round(rate * 100) : 18;

  return {
    hireTaxable: combinedHireTaxable,
    hireGst: Number(hireQuote.gst || 0),
    totalHireValueA: Number(hireQuote.grandTotal || 0),
    gstRate: rate,
    gstLabel: `GST @ ${pct}%`,
    mobilizationCollected,
    mobTaxable,
    mobGst: Number(mobQuote?.gst || 0),
    totalMobilizationB: Number(mobQuote?.grandTotal || 0),
    contractTotal: Number(booking?.total_amount || booking?.total || 0),
  };
}

export function formatContractInr(value) {
  return Number(value || 0).toLocaleString('en-IN', { maximumFractionDigits: 2 });
}
